import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-password-input',
  templateUrl: './password-input.component.html',
  styleUrls: ['./password-input.component.css']
})
export class PasswordInputComponent {
  @Input() title: string = '';
  @Input() placeholder: string = '';
  @Input() className: string = '';
  @Input() name: string = '';
  @Input() value: string = '';
  @Input() disabled: boolean = false;
  @Input() error: string | null = null;
  @Output() valueChange = new EventEmitter<string>();

  inputType: string = 'password';

  constructor(private translate: TranslateService) { }

  onInputChange(event: Event): void {
    const value = (event.target as HTMLInputElement).value;
    this.valueChange.emit(value);
  }

  onTouched(): void {
    // Handle blur event if needed
  }

  showPassword(): void {
    this.inputType = this.inputType === 'password' ? 'text' : 'password';
  }

  getTranslatedError(): string {
    if (!this.error) return '';
    return this.translate.instant(this.error);
  }
} 